import Reload from '@/pages/reload'
import CommissionsList from '@/pages/vendorPortal/commissions'
import PayoutsList from '@/pages/vendorPortal/payouts'
import PayoutsSingle from '@/pages/vendorPortal/payoutsSingle'
import SellerRegistration from '@/pages/vendorPortal/sellerRegistration'
import Unpaid from '@/pages/vendorPortal/unpaid'
// import VendorPortalDashboard from '@/pages/vendorPortal/dashboard'
import VendorPortalLogin from '@/pages/vendorPortal/login'
import VendorPortalPasswordReset from '@/pages/vendorPortal/passwordReset'
import ProductsList from '@/pages/vendorPortal/products'
import ProductsSingle from '@/pages/vendorPortal/productsSingle'
import Settings from '@/pages/vendorPortal/settings'
import Resources from '@/pages/vendorPortal/resources'
import Customers from '@/pages/vendorPortal/customers'
// import termsService from '@/pages/legal/termsService'
// import privacyPolicy from '@/pages/legal/privacyPolicy'

// import helpRoutes from '@/pages/help/routes'
import { PREFIX } from '@/localSettings'

let routes = [
  // {
  //   path: PREFIX + '/',
  //   name: 'home',
  //   component: VendorPortalDashboard
  // },
  {
    path: PREFIX + '/reload',
    name: 'reload',
    component: Reload
  },
  {
    path: PREFIX + '/',
    name: 'commissionsList',
    component: CommissionsList
  },
  {
    path: PREFIX + '/unpaid',
    name: 'unpaidList',
    component: Unpaid
  },
  {
    path: PREFIX + '/products',
    name: 'productsList',
    component: ProductsList
  },
  {
    path: PREFIX + '/products/:id',
    name: 'productsSingle',
    component: ProductsSingle
  },
  {
    path: PREFIX + '/payouts',
    name: 'payoutsList',
    component: PayoutsList
  },
  {
    path: PREFIX + '/payouts/:id',
    name: 'payoutsSingle',
    component: PayoutsSingle
  },
  {
    path: PREFIX + '/settings/',
    name: 'settings',
    component: Settings
  },
  {
    path: PREFIX + '/resources/',
    name: 'resources',
    component: Resources
  },
  {
    path: PREFIX + '/customers/',
    name: 'customers',
    component: Customers
  },
  {
    path: PREFIX + '/seller-registration/',
    name: 'sellerRegistration',
    component: SellerRegistration
  },
  // {
  //   path: PREFIX + '/terms-of-service',
  //   name: 'termsService',
  //   component: termsService
  // },
  // {
  //   path: PREFIX + '/privacy-policy',
  //   name: 'privacyPolicy',
  //   component: privacyPolicy
  // },
  {
    path: PREFIX + '/login',
    name: 'vendorPortalLogin',
    component: VendorPortalLogin
  },
  {
    path: PREFIX + '/password-reset/:uid/:token',
    name: 'vendorPortalPasswordReset',
    component: VendorPortalPasswordReset
  }
]

// routes = routes.concat(helpRoutes)

export default routes



// WEBPACK FOOTER //
// ./src/apps/vendorconsignment/portalRoutes.js